<div class="wrapper">
  <div class="main-menu" style="margin-top: 10px;">
    <!-- Sửa sub-menu -->
    <div class="select-link-page">
      <div class="content-right">
        <!-- Danh sách loại link -->
        <nz-radio-group nzName="radiogroup" 
          [(ngModel)]="data.childMenu.type"
          (ngModelChange)="onChangeAttr()">
          <label nz-radio *ngFor="let link of listLink" [nzValue]="link.url">{{link.name| translate}}</label>
        </nz-radio-group>
        <!-- Tên menu con -->
        <div class="fill-name-menu">
          <p class="title-name">{{'ten_menu_con' | translate}}: </p>
          <div style="display: flex; justify-content: center; align-items: center; gap: 12px;">
            <input nz-input placeholder="{{'nhap_ten_menu_con' | translate}}"
              [(ngModel)]="data.childMenu['name_' + functionService.languageTempCode]"
              (input)="onChangeAttr()" />
            <button *ngIf="isAutoTranslate && functionService.multi_languages.length > 1"
              type="submit" class="btn btn-warning" (click)="autoTranslateNameLang()" 
              [disabled]="!data.childMenu['name_' + functionService.languageTempCode]"
              [ngStyle]="{opacity: !data.childMenu['name_' + functionService.languageTempCode] ? .5: 1}">
              {{'dich' | translate}}
            </button>
              <!-- Chọn ngôn ngữ -->
              <div>
                  <app-select-language-config [isAdmin]="true"></app-select-language-config>
              </div>
          </div>
        </div>
        <!-- Đường dẫn liên kết -->
        <div class="fill-name-menu"  *ngIf="data.childMenu.type == 'link-page'">
          <p class="title-name">{{'duong_dan_lien_ket' | translate}}:</p>
              <div class="elementor-select">
                  <input nz-input class="field-fill" placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                      style="border-top-left-radius: 0px; border-bottom-left-radius: 0px"
                      [(ngModel)]="data.childMenu.link_page"
                      (input)="onChangeAttr()" />
              </div>
        </div>
        <!-- Liên kết website -->
        <div class="connect-page" *ngIf="data.childMenu.type == 'website'">
          <div class="fill-name-menu">
            <p class="title-name">{{'lien_ket_website_khac' | translate}}: </p>
            <div class="elementor-select">
              <input nz-input class="field-fill" placeholder="{{'nhap_duong_dan' | translate}}"
                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"
                [(ngModel)]="data.childMenu.link_website"
                (input)="onChangeAttr()"  />
            </div>
          </div>
        </div>
        <!-- Hành động khi nhấn -->
        <div class="fill-name-menu" *ngIf="data.childMenu.type == 'link-page' || data.childMenu.type == 'none'">
          <p class="title-name">{{'hanh_dong_khi_nhan' | translate}}:</p>
          <div class="elementor-select mb-2">
              <nz-select nzAllowClear class="field-fill" style="width:100%"
                  [nzPlaceHolder]="'cuon_len_dau_trang' | translate"
                  [(ngModel)]="data.childMenu.click_action"
                  (ngModelChange)="onChangeAttr()">
                  <nz-option [nzLabel]="'cuon_len_dau_trang' | translate" [nzValue]="'scroll_to_top'"></nz-option>
                  <nz-option [nzLabel]="'giu_nguyen_vi_tri' | translate" [nzValue]="'keep_position'"></nz-option>
                  <nz-option [nzLabel]="'cuon_den_khoi' | translate" [nzValue]="'scroll_to_block'"></nz-option>
              </nz-select>
          </div>

          <div *ngIf="data.childMenu.click_action == 'scroll_to_block'">
            <nz-select [(ngModel)]="data.childMenu.scroll_block_id" nzAllowClear nzPlaceHolder="Choose" nzShowSearch [nzPlaceHolder]="'chon_khoi_cuon_den' | translate">
              <nz-option-group *ngFor="let gr of data.blocks_of_page" nzLabel="{{gr['name_' + functionService.languageTempCode]}}">
                  <nz-option  *ngFor="let block of gr.blocks" [nzLabel]="block.name | translate" [nzValue]="block._id"></nz-option>
              </nz-option-group>
          </nz-select>
            <div class="form-group">
              <label for="scrollDistance">{{'khoang_cach_chua_ra_de_tranh_menu_co_dinh' | translate }}</label>
              <input type="number" nz-input class="field-fill" 
              [(ngModel)]="data.childMenu.scroll_distance"
              (input)="onChangeAttr()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="action" style="display:flex;align-items:center;justify-content: flex-end;gap: 5px;margin-top: 15px">
  <button nz-button style="margin-left: 10px;" (click)="cancelFormEditSub()">{{'huy' | translate}}</button>
  <button nz-button nzType="primary" [disabled]="!isValid" (click)="saveValueDataEdit()">{{'luu' | translate}}</button>
</div>